/**
 * 「待付金額」的資料來源：GET /app-api/customer/home 回應的 widgets.unpaid_bill。
 *
 * 由後端 app-api 加總（已定案 2026-10-04 Q3＝B＋(i)）：還沒送到的單算客戶實付、
 * 已送達的單算還欠的金額；月結、度數計費的單不算（跟帳單付）。前端不再自己加總訂單紀錄。
 * 沒有待付的單時後端回 null。
 */
export interface UnpaidBillWidget {
  total: number;
  order_count: number;
}

export interface HomeWidgetsWithUnpaid {
  unpaid_bill?: UnpaidBillWidget | null;
}

/** 首頁、帳戶頁共用：widgets.unpaid_bill?.total ?? 0 */
export const readUnpaidTotal = (widgets: HomeWidgetsWithUnpaid | null | undefined): number =>
  Number(widgets?.unpaid_bill?.total ?? 0) || 0;
